export default __webpack_public_path__ + "static/media/tempering-icon.6c5e96c3.svg";